import React from 'react';
import { Redirect } from 'expo-router';
import MetaHead from '@/components/MetaHead';
import DeckView from '@/components/Deck/DeckView';
import { useTranslation } from '@/hooks/useTranslation';
import { NeutralThemeProvider } from '@/context/ThemeContext';
import useDeckAvailability from '@/hooks/useDeckAvailability';

// The Deck route is the user's authenticated multi-column workspace.
// `DeckView` handles three states internally:
//   1. No decks yet           → offers a blank workspace or the recipe catalog.
//   2. Has decks, no slug     → activates the first deck, mirrors `?d=` URL.
//   3. Has decks + ?d=<slug>  → switches to that deck.
//
// Per-deck state and tab management live in `useDeckStore` (see
// frontend/store/index.js). Backed by `Deck` and `DeckTemplate` mongoose
// models — the deck list is server-synced and persisted across devices.
export default function DeckRoute() {
  const deckAvailable = useDeckAvailability();
  if (!deckAvailable) return <Redirect href="/" />;
  return <DeckWorkspace />;
}

function DeckWorkspace() {
  const { t } = useTranslation();
  return (
    <>
      <MetaHead
        title={t('pages.deck.title')}
        description={t('pages.deck.description')}
        canonical="/deck"
      />
      <NeutralThemeProvider><DeckView /></NeutralThemeProvider>
    </>
  );
}
